import _ from 'lodash';

export const selectServiceRequestForm = state => _.get(state, ['serviceRequestForm'], {});

export const selectServiceRequestFormIsVisible = state => _.get(selectServiceRequestForm(state), ['isVisible'], false);

export const selectServiceRequestFormStep = state => _.get(selectServiceRequestForm(state), ['step'], 0);

export const selectServiceRequestFormData = state => _.get(selectServiceRequestForm(state), ['data'], {});
